<template>
  <div class="pricesGridRowContainer" :class="backgroundColor">
    <div class="container d-flex flex-column justify-content-center align-items-center" :class="{'border-top': hasBorderTop}">
      <h4 :class="{smallTitle}">{{ title }}</h4>
      <div class="priceGrid">
        <div v-for="({price, label}, index) in priceSections" :key="index" class="priceSection">
          <span class="text-black" v-html="price" />
          <span class="text-center">{{ label }}</span>
        </div>
      </div>
      <p v-for="text in bodyText" :key="text" class="text-sm-center text-left">
        {{ text }}
      </p>
      <a v-if="showSubmitButton" class="btn btn-primary" :href="submit.url">
        {{ submit.text }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PricesGridRow',
  props: {
    backgroundColor: {
      type: String,
      required: false
    },
    bodyText: {
      type: Array,
      required: false
    },
    hasBorderTop: {
      type: Boolean,
      required: false
    },
    priceSections: {
      type: Array,
      required: true
    },
    showSubmitButton: {
      type: Boolean,
      required: false
    },
    smallTitle : {
      type: Boolean,
      required: false
    },
    title: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      submit: jsConfig.links.submit
    };
  }
};
</script>

<style lang="scss">
  @import '@sass/vue-imports.scss';

  .pricesGridRowContainer {
    .container {
      padding: 70px 0;
    }

    @include media-breakpoint-down(xs) {
      padding: 30px 0;
    }

    h4.smallTitle {
      font-size: 18px !important;
    }

    .priceGrid {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      row-gap: 50px;
      margin: 60px 0;

      @include media-breakpoint-down(xs) {
        margin: 0 0 30px;
        grid-template-columns: 1fr;
        row-gap: 0;
      }

      .priceSection {
        padding: 0 15px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;

        @include media-breakpoint-up(sm) {
          &:not(:nth-child(3n)) {
            border-right: 1px solid $light-gray;
          }
        }

        @include media-breakpoint-down(xs) {
          padding: 15px;
          &:not(:last-of-type) {
            border-bottom: 1px solid $light-gray;
          }
        }

        > span {
          &:first-of-type {
            font-size: 20px;
            line-height: 20px;
            b {
              font-size: 26px;
              line-height: 26px;
            }
          }
          &:last-of-type {
            margin-top: 15px;
          }
        }
      }
    }

    p {
      margin: 0;
      padding: 0 15px;
      &:last-of-type {
        margin-bottom: 60px;
        @include media-breakpoint-down(xs) {
          margin-bottom: 30px;
        }
      }
    }
  }
</style>
